<script setup lang="ts">
const { telegram: { bot_link } } = useAppConfig();
</script>

<template>
  <nav class="navbar bg-body-secondary sticky-top sticky-sm-off mb-2 row mx-sm-0">
    <div class="container-fluid flex-column flex-md-row align-items-stretch align-items-md-center">
      <div class="d-flex d-none d-sm-flex">
        <NuxtLink
          to="/"
          class="navbar-brand"
        >
          <img
            src="/images/navbar.png"
            height="32"
            class="d-inline-block align-top"
            :alt="$t('navbar.main')"
          > {{ $t('navbar.main') }}
        </NuxtLink>
        <a
          v-if="bot_link"
          v-tooltip="$t('navbar.telegram_bot_link_tooltip')"
          class="icon-link link-dark link-underline link-underline-opacity-0 ms-auto"
          :href="bot_link"
        >
          <i class="icon icon-xl cib-telegram-plane" />
        </a>
      </div>
      <div class="d-flex flex-column flex-md-row pt-1">
        <ClientOnly>
          <NavbarTrackingForm />
          <template #fallback>
            <span
                class="spinner-border spinner-border-sm text-success m-auto d-none d-sm-block"
                aria-hidden="true"
            />
            <div class="placeholder-glow d-sm-none">
              <input class="form-control placeholder" />
            </div>
          </template>
          <NavbarTrackingSessions class="d-sm-none" />
        </ClientOnly>
      </div>
    </div>
  </nav>
  <ClientOnly>
    <NavbarTrackingSessions class="d-none d-sm-flex" />
  </ClientOnly>
</template>
